<!-- <p-button icon="pi pi-copy"
          size="small"
          [text]="true"
          (click)="copyToClipboard()"
          [ariaLabel]="ariaLabel"
          [pTooltip]="tooltipText"
          tooltipPosition="top"
          tooltipEvent="both"
/> -->

<p-button
    type="button"
    size="small"
    [text]="true"
    (click)="copyToClipboard()"
    (keydown.enter)="copyToClipboard()"
    [ariaLabel]="ariaLabel"
    [pTooltip]="tooltipText"
    tooltipPosition="top"
    tooltipEvent="both"
>
    <mon-svg-icon name="copyAll" />
</p-button>